export const SPINNER_SIZES = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const SPINNER_TYPES = {
  PRIMARY: "primary",
  ALTERNATE: "alternate",
};
